import { render, staticRenderFns } from "./AddSaleDetail.vue?vue&type=template&id=54ee05df&"
import script from "./AddSaleDetail.vue?vue&type=script&lang=js&"
export * from "./AddSaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports